import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getOtp, studentLogin } from "../../redux/actions/auth";
import { saveState } from "../../LocalStore/localStorage";
import { connect } from "react-redux";
import decrypt from "../../utils/decrypt";
import { withRouter } from "react-router-dom";

class LoginModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: "",
      otp: null,
      inputOtp: "",
      loader: false,
      loaderOtp: false,
      modalShow: false,
      invalidOtp: false,
      hasMsisdn: false,
    };
  }

  componentDidMount() {
    const storedMsisdn = localStorage.getItem("msisdn");

    this.setState({
      hasMsisdn: !!storedMsisdn,
    });

    if (this.props.forceOpen) {
      this.setState({ modalShow: true });
    }
  }

  componentDidUpdate(prevProps) {
    // open modal when parent requests
    if (this.props.forceOpen && this.props.forceOpen !== prevProps.forceOpen) {
      this.setState({ modalShow: true });
    }
  }

  handleClose = () => {
    this.setState({ modalShow: false });
    if (this.props.onClose) this.props.onClose();
  };

  handleChange = (e) => {
    this.setState({ phoneNumber: e.target.value.trim() });
  };

  handleChangeOtp = (e) => {
    this.setState({ inputOtp: e.target.value.trim() });
  };

  // STEP 1: Request OTP
  submit = async (e) => {
    e.preventDefault();

    const { phoneNumber } = this.state;

    if (!phoneNumber) return;

    this.setState({ loader: true, invalidOtp: false });

    await this.props.dispatch(getOtp(phoneNumber));

    if (this.props.otp) {
      this.setState({
        otp: this.props.otp.otp,
        loader: false,
      });
    } else {
      this.setState({ loader: false });
    }
  };

  // STEP 2: Verify OTP + Login
  submitOtp = async (e) => {
    e.preventDefault();

    const { inputOtp, otp, phoneNumber } = this.state;

    this.setState({ loaderOtp: true, invalidOtp: false });

    try {
      const decOtp = decrypt(otp);

      if (decOtp === inputOtp) {
        await this.props.dispatch(studentLogin(phoneNumber));

        // save locally
        await saveState("msisdn", phoneNumber);

        if (this.props.userInfo) {
          await saveState("uuid", this.props.userInfo.student_id);
        }

        this.setState({
          loaderOtp: false,
          modalShow: false,
        });

        // 🔥 parent decides what happens next
        if (this.props.onLoginSuccess) {
          this.props.onLoginSuccess(phoneNumber);
        }

        this.setState({
          hasMsisdn: true,
        });
      } else {
        this.setState({
          loaderOtp: false,
          invalidOtp: true,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        loaderOtp: false,
        invalidOtp: true,
      });
    }
  };

  render() {
    const { phoneNumber, loader, otp, loaderOtp, modalShow, invalidOtp } =
      this.state;

    const currentPath = this.props.location.pathname;

    console.log("Current Path in LoginModal:", currentPath);
    console.log("HEADER LOCATION:", this.props.location);

    return (
      <>
        {!this.state.hasMsisdn &&
          currentPath.includes("sehri-notification") && (
            <div className="text-center">
              <h5 className="p-4 text-left">Kindly Login to access service</h5>
              <Button
                className="nav-link joinBtn"
                onClick={() => this.setState({ modalShow: true })}
              >
                Login
              </Button>
            </div>
          )}

        <Modal
          show={modalShow}
          onHide={this.handleClose}
          className="loginModal"
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="modalTitle text-center">
                Login to your IQRA Account
              </h4>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="loginModalBody">
              {/* STEP 1 — Phone Input */}
              {otp === null && !loader && (
                <form onSubmit={this.submit} className="loginForm">
                  <div className="form-group get-opt-form">
                    <h6 className="log-title">Enter your mobile number</h6>

                    <div className="otp-content">
                      <div className="input-number">
                        <input
                          className="form-control"
                          autoFocus
                          autoComplete="off"
                          onChange={this.handleChange}
                          placeholder="Enter Mobile Number"
                          required
                        />
                        <div className="icon">
                          <i className="fa fa-mobile"></i>
                        </div>
                      </div>

                      {phoneNumber &&
                        (phoneNumber.length < 11 ||
                          phoneNumber.length > 12) && (
                          <small className="text-danger">
                            Invalid Phone Number
                          </small>
                        )}

                      <div className="btnGroup">
                        <button
                          type="submit"
                          className="btn btn-primary form-control"
                          disabled={
                            loader || (phoneNumber && phoneNumber.length < 11)
                          }
                        >
                          Sign In {loader && <i className="spinner-border" />}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              )}

              {/* STEP 2 — OTP */}
              {otp !== null && !loader && (
                <form onSubmit={this.submitOtp} className="loginForm">
                  <div className="form-group get-opt-form otp-submit-form">
                    <h6 className="log-title">Enter OTP</h6>

                    <input
                      type="text"
                      className="form-control"
                      onChange={this.handleChangeOtp}
                      placeholder="Enter OTP"
                    />

                    {invalidOtp && (
                      <p>
                        <small className="text-danger">Invalid OTP</small>
                      </p>
                    )}

                    <br />

                    <div className="btnGroup">
                      <button
                        type="submit"
                        className="btn btn-primary form-control"
                        disabled={loaderOtp}
                      >
                        Submit {loaderOtp && <i className="spinner-border"></i>}
                      </button>
                    </div>
                  </div>

                  <div className="resendOpt">
                    <p className="text-center">
                      <Link to={"#"}>Resend OTP</Link>
                    </p>
                  </div>
                </form>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  otp: state.otp,
  userInfo: state.userInfo,
});

export default withRouter(connect(mapStateToProps)(LoginModal));
